import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import { PriceIcon } from '../../../../../components/text-icon';

export const CreateReqModalForm = ({
	categories,
	isCategoriesLoading,
	tenderTypes,
	isTenderTypesLoading,
	tenderCompanies,
	isTenderCompaniesLoading,
	types,
	isTypesLoading,
	modes,
	isModesLoading,
	isMyCarrierSelected,
	onChangeTenderType,
	onChangeCategory,
	isVisibleFetchAt,
}) => {
	return (
		<Grid className="create-req-modal-form">
			<Grid.Row className="create-req-modal-form__row">
				<Grid.Column width={5} className="create-req-modal-form__column">
					Категория
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="create-req-modal-form__column">
					<Field
						name="category_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						placeholder="Выберите категорию"
						options={categories}
						noResultsMessage="Категория не найдена"
						search
						isWithoutSelectOnBlur
						dropdownClassName="static"
						loading={isCategoriesLoading}
						disabled={isCategoriesLoading}
						onChange={onChangeCategory}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="create-req-modal-form__row">
				<Grid.Column width={5} className="create-req-modal-form__column">
					Тип ТЭО
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="create-req-modal-form__column">
					<Field
						name="tender_type_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						placeholder="Выберите тип ТЭО"
						options={tenderTypes}
						noResultsMessage="Типы ТЭО не найдены"
						search
						isWithoutSelectOnBlur
						dropdownClassName="static"
						loading={isTenderTypesLoading}
						disabled={isTenderTypesLoading}
						onChange={onChangeTenderType}
					/>
				</Grid.Column>
			</Grid.Row>
			{isMyCarrierSelected && (
				<>
					<Grid.Row className="create-req-modal-form__row">
						<Grid.Column width={5} className="create-req-modal-form__column">
							Транспортная компания
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8} className="create-req-modal-form__column">
							<Field
								name="tender_tk_id"
								type="text"
								component={FormSelectField}
								autoComplete="off"
								placeholder="Выберите транспортную компанию"
								options={tenderCompanies}
								noResultsMessage="Транспортные компании не найдены"
								search
								isWithoutSelectOnBlur
								dropdownClassName="static"
								loading={isTenderCompaniesLoading}
								disabled={isTenderCompaniesLoading}
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="create-req-modal-form__row">
						<Grid.Column width={5} className="create-req-modal-form__column">
							Стоимость доставки
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8} className="create-req-modal-form__column">
							<Field
								name="tender_amount"
								type="text"
								normalize={normalizeNumber}
								component={FormInputField}
								autoComplete="off"
								icon={PriceIcon}
								placeholder="Укажите стоимость доставки"
							/>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			{isVisibleFetchAt && (
				<>
					<Grid.Row className="create-req-modal-form__row">
						<Grid.Column width={5} className="create-req-modal-form__column">
							Дата отгрузки
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8} className="create-req-modal-form__column">
							<Field
								name="fetch_at"
								type="text"
								component={CustomDatePicker}
								autoComplete="off"
								placeholder=". . / . . / . . . ."
								dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="create-req-modal-form__row">
						<Grid.Column width={5} className="create-req-modal-form__column">
							Время отгрузки
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={4} className="create-req-modal-form__column">
							<Field
								name="fetch_time_from"
								type="time"
								component={FormInputField}
								autoComplete="off"
								placeholder="00:00"
							/>
						</Grid.Column>
						<Grid.Column width={4} className="create-req-modal-form__column">
							<Field
								name="fetch_time_to"
								type="time"
								component={FormInputField}
								autoComplete="off"
								placeholder="00:00"
							/>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			<Grid.Row className="create-req-modal-form__row">
				<Grid.Column width={5} className="create-req-modal-form__column">
					Характер груза
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="create-req-modal-form__column">
					<Field
						name="type_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						placeholder="Выберите характер груза"
						options={types}
						noResultsMessage="Характеры груза не найдены"
						search
						isWithoutSelectOnBlur
						dropdownClassName="static"
						loading={isTypesLoading}
						disabled={isTypesLoading}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="create-req-modal-form__row">
				<Grid.Column width={5} className="create-req-modal-form__column">
					Температурный режим
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="create-req-modal-form__column">
					<Field
						name="mode_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						placeholder="Выберите температурный режим"
						options={modes}
						noResultsMessage="Температурные режимы не найдены"
						search
						isWithoutSelectOnBlur
						dropdownClassName="static"
						loading={isModesLoading}
						disabled={isModesLoading}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="create-req-modal-form__row">
				<Grid.Column width={5} className="create-req-modal-form__column">
					Заявленная стоимость груза
				</Grid.Column>
				<Grid.Column width={8} className="create-req-modal-form__column">
					<Field
						name="cost"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						icon={PriceIcon}
						placeholder="Укажите заявленную стоимость груза"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

CreateReqModalForm.propTypes = {
	categories: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
	tenderTypes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
	tenderCompanies: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
	types: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
	modes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
	isCategoriesLoading: PropTypes.bool,
	isTenderTypesLoading: PropTypes.bool.isRequired,
	isTenderCompaniesLoading: PropTypes.bool.isRequired,
	isTypesLoading: PropTypes.bool.isRequired,
	isModesLoading: PropTypes.bool,
	isMyCarrierSelected: PropTypes.bool.isRequired,
	onChangeTenderType: PropTypes.func.isRequired,
	onChangeCategory: PropTypes.func.isRequired,
	isVisibleFetchAt: PropTypes.bool.isRequired,
};
